
 (function (fn) {
    "use strict";

    // element id for styles
    var elementId = fn;
    var cookieName = "cookieWarn.accepted";

    // get cookieWarn element
    var el = document.getElementById(fn);

    if (!el) {
        console.warn(fn + " element not found by id");
        return;
    }

    // get cookie warn attributes
    var getAttributes = function () {
        var parameters;


        parameters = {
            delay: parseInt(el.getAttribute("data-delay")),
            expire: parseInt(el.getAttribute("data-expire")),
            domain: el.getAttribute("data-domain"),
            path: el.getAttribute("data-path"),
            secure: el.getAttribute("data-secure"),
            debug: el.getAttribute("data-debug"),
            style: el.getAttribute("data-style"),
            class: el.getAttribute("data-class"),
            callback: el.getAttribute("data-callback")
        };

        if (parameters.secure) {            
            parameters.secure = parameters.secure == "true" ? true : false;        
        } else {
            parameters.secure =  location.protocol !== 'https:' ? false : true;
        }

        parameters.path = parameters.path ? parameters.path : "/";
        parameters.delay = parameters.delay ? parameters.delay : 500;
        parameters.expire = parameters.expire ? parameters.expire : 365;
        parameters.debug = parameters.debug == "true" ? true : false;

        if (parameters.debug) {
            console.log(parameters);
        }

        return parameters;
    };

    // get cookieWarn html attributes
    var attributes = getAttributes();

    // set or get cookie
    var cookie = function (name, value, days, path, domain, secure) {

        if (value === undefined) {
            var i,
                ckey,
                cval,
                cidx,
                cookies = document.cookie.split(";");

            for (i = 0; i < cookies.length; i++) {
                                
                cidx = cookies[i].indexOf("=");
                ckey = cookies[i].substring(0, cidx).trim();
                cval = cookies[i].substring(cidx + 1).trim();

                if (ckey == name) {
                    return cval;
                }
            }
        } else {
            var values = [];
            var expire = new Date();

            days = days ? days : 365;
            expire.setDate(expire.getDate() + days);

            if (days != undefined && days != null) {
                values.push("expires=" + expire.toGMTString());
            }

            if (path != undefined && path != null) {
                values.push("path=" + path);
            }

            if (domain != undefined && domain != null) {
                values.push("domain=" + domain);
            }

            if (secure != undefined && secure != null && secure) {
                values.push("secure");
            }

            if (values.length > 0) {
                value = value + "; " + values.join("; ");
            }

            if (attributes.debug) {
                console.log(name, value);
            }

            document.cookie = name + "=" + value;
        }
    };

    // warning box close function
    window[fn] = {
        accept: function () {
            // set the cookie
            cookie(cookieName, true, attributes.expire, attributes.path, attributes.domain, attributes.secure);

            // remove warning box
            var wbox = document.getElementById(elementId);
            wbox.className = wbox.className + " closed";

            cookieWarnValue = true;
            check(cookieWarnValue);
        },

        reject: function () {
            // set the cookie
            cookie(cookieName, false, attributes.expire, attributes.path, attributes.domain, attributes.secure);

            var wbox = document.getElementById(elementId);

            // show reject information
            if (attributes.data.reject_info) {
                wbox.className = wbox.className + " reject";
            } else {
                wbox.className = wbox.className + " closed";
            }

            cookieWarnValue = false;
            check(cookieWarnValue);
        },

        close: function () {
            console.log(elementId);
            var wbox = document.getElementById(elementId);
            wbox.className = wbox.className + " closed";
        },
    };

    var cookieWarnValue = cookie(cookieName);

    // check
    var check = function (warnValue) {

        var accepted = warnValue == "true" || warnValue === true ? true : false;

        if (attributes.debug) {
            console.log("status: " + (accepted ? "accepted" : "rejected"));
        }

        if (!attributes.callback) {
            attributes.callback = "cookieWarnCallback";
        }

        if (attributes.callback && window[attributes.callback]) {
            if (attributes.debug) {
                console.log("call: " + attributes.callback);
            }
            window[attributes.callback](accepted);
        }
    };

    var warn = function () {


        // create warning box
        //var wbox = document.createElement("div");
        var wbox = document.querySelector('#' + fn);
        console.log(wbox);
        //wbox.setAttribute("id", elementId);

        if (attributes.class) {
            wbox.setAttribute("class", attributes.class);
        }




        // append to body
        //document.body.appendChild(wbox);        

        setTimeout(function () {
            wbox.className = wbox.className + " loaded";
        }, attributes.delay);

    };

    var isDOMready = function () {
        var readyState = document.readyState;

        if (attributes.debug) {
            console.log("readyState: " + readyState);
            console.log("cookieWarnValue: " + cookieWarnValue);            
        }

        if (readyState == "complete") {
            if (!cookieWarnValue) {
                warn();
            } else {
                check(cookieWarnValue);
                //warn();
            }
        } else {
            setTimeout(function () {
                isDOMready();
            }, 200);
        }
    };

    isDOMready();
 })("show_notification");


function getBannerEl() {
    return document.getElementById('ask_permission');
}
  
if (getBannerEl()) {
    
  
  function hideBanner(res) {
    getBannerEl().style.display = 'none';
  }
  
  function showBanner() {
   getBannerEl().style.display = 'block';
  }
  
  function handleAccept(e) {
    window.Shopify.customerPrivacy.setTrackingConsent(true, hideBanner);
  
    document.addEventListener('trackingConsentAccepted',function() {
      console.log('trackingConsentAccepted event fired');
    });
  }
  
  function handleDecline() {
    window.Shopify.customerPrivacy.setTrackingConsent(false,hideBanner);
  }
  
  function initCookieBanner() {
    const userCanBeTracked = window.Shopify.customerPrivacy.userCanBeTracked();
    const userTrackingConsent = window.Shopify.customerPrivacy.getTrackingConsent();
  
    if(!userCanBeTracked && userTrackingConsent === 'no_interaction') {
      showBanner();
    }
  }


  
  window.Shopify.loadFeatures([
    {
      name: 'consent-tracking-api',
      version: '0.1',
    }
  ],
  function(error) {
    if (error) {
      throw error;
    }
  
    initCookieBanner();
      });
    
    }